import { createSelector } from 'reselect';
import { selectStripItemsOfArray } from 'webui/utils/selectors';
function validate_target_temperature(value, minValue, maxValue) {
    const ttMin = minValue === '' ? -30 : minValue;
    const ttMax = maxValue === '' ? 100 : maxValue;
    const tt = +value;
    let ttv = null;
    if ('' + tt !== value || tt < +ttMin || tt > +ttMax)
        ttv = 'Значение должно быть в [' + ttMin + '..' + ttMax + ']';
    return ttv;
}
/**
 * @function  Считаем количество единичек в числе
 * @param n - число, в котором надо посчитать все биты
 * @return number
 * https://stackoverflow.com/a/43122214
 */
export function bitCount(n) {
    // alternative way: (n).toString(2).replace(/0/g, '').length
    n = n - ((n >> 1) & 0x55555555);
    n = (n & 0x33333333) + ((n >> 2) & 0x33333333);
    return (((n + (n >> 4)) & 0xf0f0f0f) * 0x1010101) >> 24;
}
const empty_array = [];
export function select_object_array_parts(array_name, fields) {
    return createSelector((config) => (config[array_name] ?? empty_array), selectStripItemsOfArray(fields));
}
export const empty_object = {};
